import * as z from "zod";

export const getOrderTrackingAnalyticsVisibility = {
  name: "getOrderTrackingAnalyticsVisibility" as const,
  input: z.object({}),
  output: z.object({
    showEmailMetrics: z.boolean(),
    showSmsMetrics: z.boolean(),
  }),
};
